import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=51ddddcc&scoped=true"
import script from "./site-footer.vue?vue&type=script&lang=js"
export * from "./site-footer.vue?vue&type=script&lang=js"
import style0 from "./site-footer.vue?vue&type=style&index=0&id=51ddddcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddddcc",
  null
  
)

export default component.exports